import { Permission } from '@shared/infrastructure/auth/permission.js';
import type { AppModule } from '@shared/presentation/router/composition.js';
import { DATA_PERSON_ROUTE, DATA_PERSONS_ROUTE, legacyDataRedirect } from '../lib/data-routes.js';
import { VP_SECTION_NAV } from '../presentation/section-nav.js';

const DATASET_VIEW = () => import('./presentation/VideoDatasetView.vue');
const DATASET_META = { permission: Permission.VIRTUAL_PROFILER_READ, sectionNav: VP_SECTION_NAV };

/**
 * `videos` feature of Virtual Profiler.
 *
 * HU-15 a HU-24. La pantalla más cara del módulo: galería, tabla con ejecuciones
 * por grupo, subida y borrado con aviso de impacto.
 *
 * It renders inside the shell, hence `layoutRoutes`. With no `meta.public` the
 * guard protects it, which is the default.
 *
 * The gallery, the grid of people and a person's page are one screen under three addresses
 * (`lib/data-routes.ts`); the old `/virtual-profiler/videos?…` redirects to them.
 */
export const virtualProfilerVideoDatasetModule: AppModule = {
  name: 'virtual-profiler-videos',
  routes: [],
  layoutRoutes: [
    { path: 'virtual-profiler/data', redirect: { name: 'virtual-profiler-videos' } },
    {
      path: 'virtual-profiler/data/videos',
      name: 'virtual-profiler-videos',
      component: DATASET_VIEW,
      meta: DATASET_META,
    },
    {
      path: 'virtual-profiler/data/persons',
      name: DATA_PERSONS_ROUTE,
      component: DATASET_VIEW,
      meta: DATASET_META,
    },
    {
      path: 'virtual-profiler/data/persons/:personId(\\d+)',
      name: DATA_PERSON_ROUTE,
      component: DATASET_VIEW,
      meta: DATASET_META,
    },
    { path: 'virtual-profiler/videos', redirect: legacyDataRedirect },
  ],
};
